/**
 * ROOT LOADER
 *
 * Prevents routing from starting until auth context has finished loading.
 * This ensures users don't see the signin page flash before being redirected
 * to their authenticated state.
 */

import React from 'react';
import { useAuth } from '@/hooks/use-auth';

interface RootLoaderProps {
  children: React.ReactNode;
}

export function RootLoader({ children }: RootLoaderProps) {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-gray-100 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
